export default __webpack_public_path__ + "static/media/payjak-picturemark-l.117446e1.svg";